import { baseApi } from 'redux/@rtkQuery/baseApi';
import { PREFIX_API_VER_2 } from 'configs/localData/constant';
import { ParamsAPI, ResponseAPI } from 'types';
import {
  Applicant,
  Campaign,
  JobReference,
  Template,
  Workplace,
} from 'redux/@rtkQuery/jobApplication/type';

export const jobApplicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBasicInfoApplication: builder.query<ResponseAPI<Applicant>, ParamsAPI>({
      query: (params) => ({
        url: `/${PREFIX_API_VER_2}/crm/job-seekers/posts/applicant/basic-info`,
        params,
      }),
    }),
    getJobReferenceApplication: builder.query<
      ResponseAPI<JobReference>,
      ParamsAPI
    >({
      query: (params) => ({
        url: `/${PREFIX_API_VER_2}/crm/job-seekers/posts/job-reference/basic-info`,
        params,
      }),
    }),
    getCampaignsApplication: builder.query<ResponseAPI<Campaign>, ParamsAPI>({
      query: (params) => ({
        url: `/${PREFIX_API_VER_2}/crm/job-seekers/campaigns/basic-info`,
        params,
      }),
    }),
    getJobTemplateApplication: builder.query<ResponseAPI<Template>, ParamsAPI>({
      query: (params) => ({
        url: `/${PREFIX_API_VER_2}/crm/job-seekers/posts/templates/basic-info`,
        params,
      }),
    }),
    getWorkplaceApplication: builder.query<ResponseAPI<Workplace>, ParamsAPI>({
      query: (params) => ({
        url: `/${PREFIX_API_VER_2}/crm/job-seekers/posts/workplaces/basic-info`,
        params,
      }),
    }),
  }),
});

export const {
  useGetBasicInfoApplicationQuery,
  useGetJobReferenceApplicationQuery,
  useGetCampaignsApplicationQuery,
  useGetJobTemplateApplicationQuery,
  useGetWorkplaceApplicationQuery,
} = jobApplicationApi;
